export const EXPERIMENTS = {
  SIERRA_CHAT: {
    KEY: "cchp_sierra",
    VARIATIONS: {
      CONTROL: "1",
      VARIANT: "2",
    },
    EVENTS: {
      NUANCE: "nuance_chatbot_load",
      SIERRA: "sierra_chatbot_load",
    },
  },
};
